import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';

export const Contact = () => {
  const content = useSiteContent();

  return (
    <div className="min-h-screen bg-black">
      <section className="py-20 lg:py-32">
        <div className="container mx-auto px-4 lg:px-8">
          <h1 className="text-5xl lg:text-6xl font-black text-white mb-16 text-center">{content?.contactTitle || 'CONTACTEZ-NOUS'}</h1>

          <div className="max-w-2xl mx-auto text-center">
            <p className="text-white/80 text-xl leading-relaxed mb-16">{content?.contactSubtitle || 'Vous avez des questions ? N\'hésitez pas à nous contacter. Nous serons ravis de vous répondre.'}</p>

            <div className="space-y-10">
              <div className="flex flex-col items-center space-y-3">
                <div className="w-16 h-16 bg-[#FF1B6D] rounded-lg flex items-center justify-center">
                  <MapPin size={32} className="text-white" />
                </div>
                <h3 className="text-white font-bold text-2xl">ADRESSE</h3>
                <p className="text-white/70 text-lg">{content?.contactAddress || 'Ain, France'}</p>
              </div>

              <div className="flex flex-col items-center space-y-3">
                <div className="w-16 h-16 bg-[#FF1B6D] rounded-lg flex items-center justify-center">
                  <Mail size={32} className="text-white" />
                </div>
                <h3 className="text-white font-bold text-2xl">EMAIL</h3>
                <p className="text-white/70 text-lg">{content?.contactEmail || 'contact@zeroun.fr'}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};